import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Field } from '@/shared/lib/withField';
import { computed, toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputTextValidate',
  props: {
    modelValue: null
  },
  emits: ["update:modelValue", "input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue'): void;
  (e: 'input', v: Event): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: Field;
}



const valueRef = toRefs(props).modelValue.value;
const value = computed({
  get: () => valueRef.value as string,
  set: (v: string) => {
    valueRef.value = v;
  },
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    type: "text",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
    class: "input-text",
    onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (__props.modelValue.forceValidate && __props.modelValue.forceValidate(...args))),
    onInput: _cache[2] || (_cache[2] = ($event: any) => (emit('input', $event)))
  }, null, 544)), [
    [_vModelText, _unref(value)]
  ])
}
}

})